import _ from "lodash";

export const progress = state => key => {
    return _.get(state.progress, key, false)
}

export const batches = state => {
    return _.get(state, 'batches', [])
}

export const batchSamples = state => batchId => {
    return _.get(state.sampleBatchesByBatchId, [batchId], {})
}

export const batchStatus = state => key => {
    return _.get(state.availableBatchStatusesByValue, [key, 'title'], key)
}

export const getBatchCurrentPage = state => {
    return state.pagination.page
}

export const getTotalBatchPages = state => {
    if (state.totalBatches) {
        return Math.ceil(state.totalBatches / state.pagination.rowsPerPage)
    }
    return 1
}
